import {
	Menu,
	MenuHeader,
	MenuItem,
	MenuPopover,
	MenuPressable,
	MenuSection,
	MenuSeparator,
	MenuTrigger,
	P,
	Stack,
	Text,
	ToggleChevron,
	useLogin,
	useText,
} from "@sveabank/cc-common";
import { useState } from "react";
import Avatar from "../../components/avatar";

type Props = {
	abortApplication: () => void;
	allowNavigation: boolean;
	companyName?: string;
	orgNr?: string;
};

const TopNavigation = ({ abortApplication, allowNavigation, companyName, orgNr }: Props) => {
	const [t, texts] = useText();
	const { doLogout } = useLogin();
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	const firstCharacter = companyName?.slice(0, 1) || "F"; // todo: some other letter?

	return (
		<MenuTrigger isOpen={isMenuOpen} onOpenChange={setIsMenuOpen}>
			<MenuPressable label="Öppna användarmeny">
				<Stack direction="row" gap={4} justify="start">
					<Avatar>{firstCharacter}</Avatar>
					<div className="tablet:flex hidden flex-col text-left whitespace-nowrap">
						<P bold className="text-interactive-primary">
							{companyName}
						</P>
						<P className="text-interactive-primary">{orgNr || t(texts.header.noOrgNr)}</P>
					</div>
					<ToggleChevron open={isMenuOpen} />
				</Stack>
			</MenuPressable>

			<MenuPopover placement="bottom end" className="tablet:w-64">
				<Menu>
					<MenuSection className="bg-background-secondary tablet:hidden block">
						<MenuHeader>
							<Stack>
								<Text className="text-interactive-primary font-semibold">{companyName}</Text>
								<Text className="text-interactive-primary">{orgNr || t(texts.header.noOrgNr)}</Text>
							</Stack>
						</MenuHeader>
					</MenuSection>
					<MenuSection>
						{allowNavigation && (
							<MenuItem onPress={abortApplication}>
								<Text bold>{t(texts.header.abortApplication)}</Text>
							</MenuItem>
						)}
						<MenuSeparator />
						<MenuItem href="/dashboard">
							<Text bold>{t(texts.header.backToDashboard)}</Text>
						</MenuItem>
						<MenuItem
							onPress={() => doLogout()}
							className="bg-interactive-primary ring-interactive-primary hover:bg-interactive-primary-hover rounded-b-md ring-1"
						>
							<Text bold className="text-text-contrast w-full text-center">
								{t(texts.header.logout)}
							</Text>
						</MenuItem>
					</MenuSection>
				</Menu>
			</MenuPopover>
		</MenuTrigger>
	);
};

export default TopNavigation;
